import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Chip, TextField } from '@mui/material';
import { AlumnoType } from '../../types/types';
import { useContext, useEffect, useState } from 'react';
import { UseAddHnos } from '../../hooks/hermanos';
import { UserContext } from '../../contexts/userContext';


interface AgregarHnoProps {
  open: boolean;
  onCancell: () => void;
  onUpdate: () => void;
  lista: AlumnoType[];
  alumno: string;
  hermanos: string[];
}

export default function AgregarHermanos(props: AgregarHnoProps) {
  const { open, onCancell, lista, alumno, hermanos, onUpdate } = props;
  const [filtro, setFiltro] = useState('');
  const { user } = useContext(UserContext);

  const [newHnos, setNewHnos] = useState<string[]>([alumno]);

  const addHnos = UseAddHnos(newHnos, user);

  useEffect(() => {
    if (addHnos.data) onUpdate();
  }, [addHnos.data]);

  if (!lista) return null;

  const filtrado = lista?.filter((a) => !hermanos.includes(a._id)
  && (a.apellido?.toUpperCase().includes(filtro?.toUpperCase()) || a.name?.toUpperCase().includes(filtro?.toUpperCase())),
  );


  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth='md'
        PaperProps={{
          sx: {
            minHeight: '70vh',
            maxHeight: '70vh',
          },
        }}
      >
        <DialogTitle>Agregar Hermanos</DialogTitle>
        <DialogContent>
          <Box style={{ marginTop: 24 }}>
            <TextField
              margin="dense"
              id="buscar"
              label="Buscar"
              type="text"
              fullWidth
              variant="standard"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFiltro(event.target.value);
              }}
              value={filtro}
            />
            {filtrado?.map((a) => (
              <Chip
                key={a._id}
                label={`${a.name} ${a.apellido}`}
                onClick={() => {if (!newHnos.includes(a._id)) setNewHnos([...newHnos, a._id]);}}
                size="small"
                style={{ margin: 4 }}
              />
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancell}>Salir</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
